module.exports = __webpack_public_path__ + "img/icon_map_3_5_yj_hg_c.f4515c4c.png";